import { render, staticRenderFns } from "./AnswerDetailDialog.vue?vue&type=template&id=62244f77&scoped=true"
import script from "./AnswerDetailDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AnswerDetailDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AnswerDetailDialog.vue?vue&type=style&index=0&id=62244f77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62244f77",
  null
  
)

export default component.exports